import React from 'react';
import { ArrowLeft } from 'lucide-react';
import Banterboard from '../banter/Banterboard';

/**
 * The whole House board.
 *
 * One page of thirty posts and no "load more". The server paginates by cursor and has
 * done since the boards shipped, but at the rate this board realistically moves — a line
 * or two a week — thirty posts is most of a season, and a paging control on a page that
 * will not need one for months is a control to keep working for months. It goes in when
 * thirty stops being enough.
 *
 * Reached from the panel on the home page, and only once there is more up there than the
 * three that panel shows: a link that leads to the same three posts is worse than no
 * link. It is a real page rather than an expander for the same reason every other screen
 * here is — an email or a notice needs somewhere to point.
 */
function HouseBoardPage({ onBack }) {
  return (
    <div className="page-container fade-in">
      <div className="content-card">
        <button type="button" className="secondary-btn league-back" onClick={onBack}>
          <ArrowLeft size={18} />
          Back
        </button>

        <div className="house-page-head">
          <h1>From the house</h1>
          <p>
            Fixture changes, results and whatever the Gaffer has to say about them.
            Everybody sees the same board; only the house posts to it.
          </p>
        </div>

        <Banterboard house />
      </div>
    </div>
  );
}

export default HouseBoardPage;
